import {
  DayPeriodFilter,
  MonthPeriodFilter,
  WeekPeriodFilter,
  YearPeriodFilter,
} from "./general";
import type { PeriodType } from "./types";

export const PERIODS: { id: PeriodType; label: string; Filter: any }[] = [
  { id: "day", label: "Jour", Filter: DayPeriodFilter },
  { id: "week", label: "Semaine", Filter: WeekPeriodFilter },
  { id: "month", label: "Mois", Filter: MonthPeriodFilter },
  { id: "year", label: "Année", Filter: YearPeriodFilter },
];
